import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Button, Typography } from "@bookips/sds";
import Image from "next/image";
import Link from "next/link";
// $텍스트$ 패턴을 파싱하여 강조 스타일 적용
const parseAccentTitle = (title)=>{
    const parts = title.split(/(\$[^$]+\$)/g).filter(Boolean);
    return parts.map((part, index)=>{
        if (part.startsWith("$") && part.endsWith("$")) {
            return /*#__PURE__*/ _jsx("span", {
                className: "text-primary-main",
                children: part.slice(1, -1)
            }, index);
        }
        return part;
    });
};
const HomeSectionLayout = (param)=>{
    let { title , header , isUseButton , buttonText , buttonUrl , titleImageUrl , onCtaClick , children  } = param;
    const isUnUseHeader = !titleImageUrl && !header && !title && !isUseButton;
    return /*#__PURE__*/ _jsxs("section", {
        className: cn("my-10 flex w-full flex-col max-sm:my-6", isUnUseHeader ? "gap-0 max-sm:gap-0" : "gap-5 max-sm:gap-3"),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: cn("flex w-full items-center max-lg:px-8 max-sm:px-5"),
                children: [
                    titleImageUrl && /*#__PURE__*/ _jsx(Image, {
                        src: titleImageUrl,
                        alt: title !== null && title !== void 0 ? title : "",
                        width: 64,
                        height: 64,
                        className: "max-sm:h-12 max-sm:w-12"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex w-full flex-col",
                        children: [
                            header && /*#__PURE__*/ _jsx(Typography, {
                                variant: "body1",
                                className: "text-primary max-sm:typo-body2",
                                children: header
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    title && /*#__PURE__*/ _jsx(Typography, {
                                        variant: "h4",
                                        className: "text-primary max-sm:typo-h6 break-keep",
                                        children: parseAccentTitle(title)
                                    }),
                                    isUseButton && /*#__PURE__*/ _jsx(Button, {
                                        asChild: true,
                                        variant: "stroke",
                                        color: "secondary",
                                        size: "md",
                                        className: "max-sm:hidden",
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: buttonUrl,
                                            onClick: onCtaClick,
                                            children: buttonText
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
export const HomeSectionTitle = (param)=>{
    let { title , header , isUseButton , buttonText , buttonUrl , titleImageUrl , onCtaClick  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full items-center gap-5 max-lg:px-8 max-sm:gap-3 max-sm:px-5",
        children: [
            titleImageUrl && /*#__PURE__*/ _jsx(Image, {
                src: titleImageUrl,
                alt: title !== null && title !== void 0 ? title : "",
                width: 64,
                height: 64,
                className: "max-sm:h-12 max-sm:w-12"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex w-full flex-col",
                children: [
                    header && /*#__PURE__*/ _jsx(Typography, {
                        variant: "body1",
                        className: "text-primary max-sm:typo-body2",
                        children: header
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-between",
                        children: [
                            title && /*#__PURE__*/ _jsx(Typography, {
                                variant: "h4",
                                className: "text-primary max-sm:typo-h6 break-keep",
                                children: parseAccentTitle(title)
                            }),
                            isUseButton && /*#__PURE__*/ _jsx(Button, {
                                asChild: true,
                                variant: "stroke",
                                color: "secondary",
                                size: "md",
                                className: "max-sm:hidden",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    href: buttonUrl,
                                    onClick: onCtaClick,
                                    children: buttonText
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default HomeSectionLayout;
